import React from 'react';
import Responsive from 'react-responsive';

export const TabletBreakpoint = 1024;
export const MobileBreakpoint = 768;
export const FullHDBreakpoint = 1920;

// For use on radium styles
export default {
  fullHD: `@media only screen and (min-width: ${FullHDBreakpoint}px)`,
  desktop: `@media only screen and (min-width: ${TabletBreakpoint}px)`,
  tablet: `@media only screen and (min-width: ${MobileBreakpoint}px) and
   (max-width: ${TabletBreakpoint - 1}px)`,
  mobile: `@media only screen and (max-width: ${MobileBreakpoint - 1}px)`,

  // Grouped viewports
  desktop_tablet: `@media only screen and (min-width: ${MobileBreakpoint}px)`,
  tablet_mobile: `@media only screen and (max-width: ${TabletBreakpoint - 1}px)`
};

// For conditional rendering
export const DesktopViewport = ({ children }) => (
  <Responsive minWidth={TabletBreakpoint}>{children}</Responsive>
);
export const TabletViewport = ({ children }) => (
  <Responsive minWidth={MobileBreakpoint} maxWidth={TabletBreakpoint - 1}>
    {children}
  </Responsive>
);
export const MobileViewport = ({ children }) => (
  <Responsive maxWidth={MobileBreakpoint - 1}>{children}</Responsive>
);

// Group tablet & desktop viewport
export const DefaultViewport = ({ children }) => (
  <Responsive minWidth={MobileBreakpoint}>{children}</Responsive>
);
export const TabletMobileViewport = ({ children }) => (
  <Responsive maxWidth={TabletBreakpoint - 1}>{children}</Responsive>
);
